import React from 'react'
import { Button } from '@microservices/wiskey-react-components'

import { buttonStylesByMode } from '@helpers'

interface ConfiguredEntityCreateButtonProps {
  text: string | undefined
  isViewDialogWindow: boolean
  onCreate: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export const ConfiguredEntityCreateButton: React.FC<ConfiguredEntityCreateButtonProps> = props => {
  const { text, isViewDialogWindow, onCreate: handleCreate } = props

  return (
    <Button
      variant='outlined'
      sx={theme => ({
        ...buttonStylesByMode(theme, isViewDialogWindow),
        zIndex: 2,
        mr: 1.5,
      })}
      onClick={handleCreate}
    >
      {text}
    </Button>
  )
}

ConfiguredEntityCreateButton.displayName = 'ConfiguredEntityCreateButton'
